module.exports = __webpack_public_path__ + "static/media/22ESCWA3.b0b5be1a.jpg";